import { BackendFilter, FilterOperator } from '../../../../interfaces/sessions';
import { SessionDetailView, SessionHistoryTabs } from '../../../../components/History/views';
import { BackendTables, ConversationType } from '../../../../interfaces/db';
import { SessionV2Columns, CallbackRequestColumns, CallMetricColumns } from '../../../../interfaces/table';
import { MS_TO_MICRO } from '../../../../cfg/const';
import { roundDateDown } from '../../filters/slice';

export type SessionListProps = {
  passed_filter?: BackendFilter | null, 
  enforced_start?: Date | null, 
  enforced_end?: Date | null,
  tab: SessionHistoryTabs,
  view: SessionDetailView,
  disableDebouncing?: boolean,
}

const call_filter: BackendFilter = [[{
  column_name: SessionV2Columns.CONVERSATION_TYPE,
  table: BackendTables.SESSIONS_V2,
  operator: FilterOperator.EQ,
  value_safe: ConversationType.CALL
}]];

const text_filter: BackendFilter = [[{
  column_name: SessionV2Columns.CONVERSATION_TYPE,
  table: BackendTables.SESSIONS_V2,
  operator: FilterOperator.EQ,
  value_safe: ConversationType.MESSAGING
}]];

const callback_filter: BackendFilter = [
  [{
    column_name: CallbackRequestColumns.CALLBACK_TIMING,
    table: BackendTables.CALLBACK_REQUEST_DETAILS,
    operator: FilterOperator.GT,
    value_safe: roundDateDown((new Date(new Date().getTime() - 14* 24 * 60 * 60 * 1000))).getTime() * MS_TO_MICRO // 28 days ago
  }], [{
    column_name: CallbackRequestColumns.CALLBACK_STATUS,
    table: BackendTables.CALLBACK_REQUEST_DETAILS,
    operator: FilterOperator.IN,
    value_safe: ['BRUSH_OFF', 'REFERRAL', 'BUSY', 'EXPLICIT_CALLBACK_TIME', 'GATEKEEPER_CALLBACK', 'GATEKEEPER_NO_CALLBACK', 'NURTURE']
  }]
];

const chat_filter: BackendFilter = [[{
  column_name: SessionV2Columns.CONVERSATION_TYPE,
  table: BackendTables.SESSIONS_V2,
  operator: FilterOperator.EQ,
  value_safe: ConversationType.CHAT
}]];

const incoming_missed_calls: BackendFilter = [
  [{
    column_name: CallMetricColumns.IS_INBOUND,
    table: BackendTables.CALL_METRICS,
    operator: FilterOperator.EQ,
    value_safe: true
  }],[{
    column_name: CallMetricColumns.FIRST_USER_JOINED_AT,
    table: BackendTables.CALL_METRICS,
    operator: FilterOperator.EQ,
    value_safe: null
  }]
];

export const TAB_TO_BACKEND_FILTER = {
  [SessionHistoryTabs.CALLS]: call_filter,
  [SessionHistoryTabs.CALLBACKS]: [...callback_filter, ...call_filter],
  [SessionHistoryTabs.TEXTS]: text_filter,
  [SessionHistoryTabs.MISSED]: [...call_filter, ...incoming_missed_calls],
  [SessionHistoryTabs.CHAT]: chat_filter,
  [SessionHistoryTabs.ALL_HISTORY]: [] as BackendFilter,
} as const; 